import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useDrawerContext } from '../shared/contexts';
import {
    Dashboard,
    Establishment,
    UpsertEstablishment,
    User,
    UpsertUser,
} from '../pages';
import { ClientCompany } from 'pages/clientCompany/ClientCompany';
import { UpsertClientCompany } from 'pages/clientCompany/UpsertClientCompany';

export const AppRoutes = () => {
    const { setDrawerOptions } = useDrawerContext();

    useEffect(() => {
        setDrawerOptions([
            {
                icon: 'home',
                path: '/home',
                label: 'Home',
            },
            {
                icon: 'group',
                path: '/user',
                label: 'Usuários',
            },
            {
                icon: 'storefront',
                path: '/establishment',
                label: 'Estabelecimentos',
            },
            {
                icon: 'business',
                path: '/clientCompany',
                label: 'Empresas Parceiras'
            },
        ]);
    }, [setDrawerOptions]);

    return (
        <Routes>
            <Route path="/home" element={<Dashboard />} />

            <Route path="/user" element={<User />} />
            <Route path="/user/detalhe/:id" element={<UpsertUser />} />

            <Route path="/establishment" element={<Establishment />} />
            <Route path="/establishment/detalhe/:id" element={<UpsertEstablishment />} />

            <Route path="/clientCompany" element={<ClientCompany />} />
            <Route path="/clientCompany/detalhe/:id" element={<UpsertClientCompany />} />

            <Route path="*" element={<Navigate to="/home" />} />
        </Routes>
    );
};